import { IMGIX_ENV, IMGIX_URL } from '../src/env';

export const getImgxSrc = (path: string) => `${IMGIX_URL}/${IMGIX_ENV}/${path}`;

export const getArticleImgSrc = (id?: number, picture?: string) => {
  if (!picture) return getImgxSrc(`/articles/article_default.jpg`);
  return getImgxSrc(`/articles/${id}/${picture}`);
};
